<template>
  <!-- _________________________ REGISTER _________________________ -->
  <div id="register-div" class="position-absolute">

    <div class="mt-4 d-flex justify-content-between" @click="showLoginView(false)">
      <back-arrow :title="$t('RegisterTitle')"/>
    </div>

    <h2 class="page-subtitle mt-3">
      {{ $t('RegisterSubtitle') }}
    </h2>

    <form ref="form" @submit.stop.prevent="handleSubmit">

      <div class="row">

        <!-- nom -->
        <div class="col-md-6">
          <string-field
            :label="$t('user.Lastname') + ' *'"
            :id="'lastname-input'"
            :input-value="this.form.lastname"
            v-model="this.form.lastname"
            :is-required="true">
          </string-field>
        </div>

        <!-- prénom -->
        <div class="col-md-6">
          <string-field
            :label="$t('user.Firstname') + ' *'"
            :id="'firstname-input'"
            :input-value="this.form.firstname"
            v-model="this.form.firstname"
            :is-required="true">
          </string-field>
        </div>

      </div>

      <!-- téléphone -->
      <phone-number-field
        :phone-number="this.form.phoneNumber"
        v-model="this.form.phoneNumber">
      </phone-number-field>

      <!-- email -->
      <string-field
        :label="$t('user.Username') + ' *'"
        :id="'username-input'"
        :input-value="this.form.username"
        v-model="this.form.username"
        :type="'email'"
        :is-required="true">
      </string-field>

      <!-- mot de passe -->
      <password-creation-field
        :password="form.password"/>

      <password-creation-field
        :password="form.passwordRepeat"
        :label="$t('user.Password.confirm')"/>

      <b-form-checkbox
        id="rgpd-input"
        name="rgpd-input"
        required>
        <p>{{ $t('user.rgpd')}} <b-link href="https://quinzaine.japonoccitanie.fr/politique-de-confidentialite/" target="_blank">{{$t('user.policy')}}.</b-link></p>
        <p>{{ $t('user.rgpd2')}} <b-link href="mailto:mesdonnees@japonoccitanie.fr">mesdonnees@japonoccitanie.fr</b-link></p>
      </b-form-checkbox>

      <div class="mt-4 mb-4">
        <b-button type="submit" class="btn-block" variant="primary">
          <span v-if="!isLoading">{{ $t('RegisterTitle') }}</span>
          <b-spinner v-else :label="$t('spinner.isLoading')" small></b-spinner>
        </b-button>
      </div>

    </form>

  </div>
</template>

<script>

import api from '../../../services/api'
import i18n from "../../../i18n"
import BackArrow from "../../../components/b122/BackArrow.vue"
import PhoneNumberField from "../../../components/b122/editFields/PhoneNumberField.vue"
import PasswordCreationField from "../../../components/b122/editFields/PasswordCreationField.vue";
import StringField from "../../../components/b122/editFields/StringField.vue";

export default {

  name: 'RegisterComponent',
  components: {
    StringField,
    PasswordCreationField,
    PhoneNumberField,
    BackArrow
  },

  data: function () {
    return {
      isLoading: false,
      form: {
        firstname:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastname:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            value: null,
            formattedNumber: null,
            countryCode: null
          },
        password: {
          value: null,
          state: null,
          invalidFeedback: null
        },
        passwordRepeat: {
          value: null,
          state: null,
          invalidFeedback: null
        }
      }
    }
  },

  emits: ['showLoginView'],

  mounted () {
  },

  methods: {

    handleSubmit () {

      this.isLoading = true

      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('firstname', this.form.firstname.value)
      formData.append('lastname', this.form.lastname.value)
      formData.append('username', this.form.username.value)
      formData.append('phoneNumber', this.form.phoneNumber.formattedNumber)
      formData.append('phoneCountryCode', this.form.phoneNumber.countryCode)
      formData.append('password', this.form.password.value)

      api({
        method: 'POST',
        url: `/register/register`,
        data: formData
      })
        .then( () => {
          this.showLoginView(true)
          this.successToast()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
          }
        })
    },

    isFormValid () {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }
      if (this.form.password.value == null || this.form.password.value.trim() === '') {
        this.form.password.state = false
        this.form.password.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.form.password.value.trim().length < 8) {
        this.form.password.state = false
        this.form.password.invalidFeedback = this.$i18n.t('Password.minlenght.error')
        return false
      } else if (this.form.passwordRepeat.value == null || this.form.passwordRepeat.value.trim() === '') {
        this.form.passwordRepeat.state = false
        this.form.passwordRepeat.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.form.password.value !== this.form.passwordRepeat.value) {
        this.form.passwordRepeat.state = false
        this.form.passwordRepeat.invalidFeedback = this.$i18n.t('NewPassword.not.corresponding')
        return false
      }
      return true
    },

    removeInvalidFeedback (field) {
      this.form[field]['state'] = null
    },

    successToast () {
      this.$bvToast.toast(this.$i18n.t('Register.success'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    showLoginView (accountCreationSuccess) {
      this.$emit('showLoginView', accountCreationSuccess)
    },

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/components/RegisterComponent.vue